import { Flex, Skeleton } from "@mantine/core";

/** Linhas da coluna "Áreas": nome, "N pessoas" e o selo da IA. */
export function AreaRowsSkeleton({ rows = 3 }: { rows?: number }) {
  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        <Flex
          key={index}
          align="center"
          gap={10}
          px={20}
          py={12}
          data-testid="area-row-skeleton">
          <Flex
            direction="column"
            gap={6}
            flex={1}>
            <Skeleton
              height={12}
              width="55%"
            />
            <Skeleton
              height={10}
              width="35%"
            />
          </Flex>
          <Skeleton
            height={18}
            width={84}
            radius="xl"
          />
        </Flex>
      ))}
    </>
  );
}
